import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rft-pagination-wrapper',
  template: ` <ng-content></ng-content> `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaginationWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
